<template>
	<div class="limit-page">

		<!-- HEADER -->
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">
					Upgrade Your Account Limit
				</h2>
			</div>
		</div>

		<!-- CONTENT -->
		<div class="container main-section">

			<!-- LIMIT CARD -->
			<div class="limit-card">

				<div class="limit-row">

					<!-- PROGRESS -->
					<div class="progress-wrapper">

						<div class="circle"
							 :style="{
								background:
								'conic-gradient(#e60023 ' +
								usedPercent +
								'%, #eee 0)'
							 }">

							<div class="circle-inner">

								<div class="percent">
									{{ usedPercent }}%
								</div>

								<div class="label">
									Balance
								</div>

							</div>

						</div>

					</div>

					<!-- BALANCE INFO -->
					<div class="balance-info">

						<h3>Balance Limit</h3>

						<div class="amount">
							{{ formatMoney(balanceUsed) }} MYR
						</div>

						<div class="sub">
							out of {{ formatMoney(balanceLimit) }} MYR
						</div>

						<div class="bonus-limit">
							Bonus Limit:
							<strong>
								{{ formatMoney(bonusLimit) }} MYR
							</strong>
						</div>

					</div>

				</div>

				<button class="btn-increase"
						@click="goToIncreaseLimit" v-if="IsUpgradeAllowed">

					Increase Limit

				</button>

			</div>

			<!-- STATUS CARD -->
			<div class="status-card">

				<div class="status-icon">
					🚀
				</div>

				<div class="status-text">

					<div class="title">
						{{ statusText }}
					</div>

					<div class="sub">
						Upgrade Limit Status
					</div>

				</div>

				<div class="arrow">
					›
				</div>

			</div>

			<!-- HISTORY -->
			<div class="history-section">

				<h3>Account Limit History</h3>

				<div v-if="history.length === 0"
					 class="no-history">

					No History Found

				</div>

				<div v-for="(item, index) in history"
					 :key="index"
					 class="history-item">

					<div class="icon">
						📄
					</div>

					<div class="info">

						<div class="title">
							{{ formatDate(item.StartDate) }}
						</div>

						<div class="date">
							{{ formatDate(item.StartDate) }}
						</div>

					</div>

					<div class="amount">
						{{ formatMoney(item.Amount) }} MYR
					</div>

				</div>

			</div>

		</div>

	</div>
</template>

<script>
	export default {
		name: "UpgradeAccountLimit",

		data() {
			return {

				usedPercent: 0,
				balanceUsed: 0,
				balanceLimit: 0,
				bonusLimit: 0,
				statusText: "",
				IsUpgradeAllowed: false,
				history: []
			};
		},

		created() {
			this.loadDashboard();
		},

		methods: {

			loadDashboard() {

				this.$http
					.get("customizetransactionlimit/dashboard")
					.then(response => {

						const data = response.body;

						this.usedPercent = data.BalancePercent || 0;

						// balanceUsed = balanceLimit from API
						this.balanceUsed = data.BalanceLimit || 0;

						// balanceLimit = baseLimit from API
						this.balanceLimit = data.BaseLimit || 0;

						this.bonusLimit = data.BonusLimit || 0;

						this.statusText = data.StatusText || "No Status";

						// history binding
						this.history =
							data.TransactionLimitHistory || [];
						this.IsUpgradeAllowed = data
							.IsUpgradeAllowed || false;
					});
			},

			formatMoney(value) {

				if (!value)
					return "0.00";

				return Number(value).toLocaleString(
					"en-MY",
					{
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}
				);
			},

			formatDate(date) {

				if (!date)
					return "";

				return new Date(date)
					.toLocaleDateString(
						"en-GB",
						{
							day: "2-digit",
							month: "short",
							year: "numeric"
						}
					);
			},

			goToIncreaseLimit() {

				this.$router.push("/IncreaseLimit");
			}
		}
	};
</script>

<style scoped>

	.main-section {
		padding-top: 30px;
		padding-bottom: 30px;
	}

	/* CARD */
	.limit-card {
		background: #fff;
		border-radius: 18px;
		padding: 20px;
		box-shadow: 0 2px 12px rgba(0,0,0,0.06);
		margin-bottom: 15px;
	}

	.limit-row {
		display: flex;
		align-items: center;
		gap: 20px;
	}

	/* PROGRESS */
	.circle {
		width: 95px;
		height: 95px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.circle-inner {
		width: 72px;
		height: 72px;
		background: #fff;
		border-radius: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.percent {
		font-weight: bold;
		font-size: 18px;
		color: #e60023;
	}

	.label {
		font-size: 12px;
		color: #888;
	}

	/* BALANCE */
	.balance-info h3 {
		margin: 0;
		font-size: 14px;
		color: #888;
	}

	.amount {
		font-size: 22px;
		font-weight: bold;
		margin-top: 5px;
	}

	.sub {
		font-size: 13px;
		color: #999;
		margin-top: 4px;
	}

	.bonus-limit {
		margin-top: 10px;
		font-size: 13px;
		color: #444;
	}

	/* BUTTON */
	.btn-increase {
		width: 100%;
		margin-top: 20px;
		background: #e60023;
		color: #fff;
		border: none;
		padding: 12px;
		border-radius: 10px;
		font-weight: bold;
		font-size: 15px;
		cursor: pointer;
	}

		.btn-increase:hover {
			opacity: 0.9;
		}

	/* STATUS */
	.status-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff3e6;
		padding: 15px;
		border-radius: 12px;
		margin-bottom: 20px;
	}

	.status-icon {
		font-size: 22px;
	}

	.status-text {
		flex: 1;
		margin-left: 10px;
	}

		.status-text .title {
			font-weight: bold;
			font-size: 15px;
		}

		.status-text .sub {
			font-size: 12px;
			color: #777;
		}

	.arrow {
		font-size: 22px;
		color: #888;
	}

	/* HISTORY */
	.history-section h3 {
		font-size: 16px;
		margin-bottom: 12px;
		font-weight: bold;
	}

	.history-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px;
		background: #fff;
		border-radius: 10px;
		margin-bottom: 10px;
		box-shadow: 0 1px 6px rgba(0,0,0,0.05);
	}

		.history-item .icon {
			font-size: 18px;
			margin-right: 10px;
		}

		.history-item .info {
			flex: 1;
		}

		.history-item .title {
			font-weight: bold;
			font-size: 14px;
		}

		.history-item .date {
			font-size: 12px;
			color: #888;
			margin-top: 3px;
		}

		.history-item .amount {
			font-weight: bold;
			font-size: 15px;
			color: #222;
		}

	.no-history {
		padding: 15px;
		background: #fff;
		border-radius: 10px;
		text-align: center;
		color: #888;
	}
</style>
